import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import AboutUs1stpic from "../../images/AboutUs1stpic.png";

const PGAboutUs = () => {
  return (
    <div className="QL__PG__PGAboutUsSecwhowe">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Who We Are</h1>
              <p className="pt-3">
                The team behind LearnQuranQuick aims to provide the Muslim ummah
                with an affordable and efficient convenience of learning and
                understanding the Quran and its tajweed online. LearnQuranQuick
                tutors utilize modern-day technologies (like zoom calls,
                recorded calls, online assignments, and quizzes relevant to
                Quran’s teachings) to improvise their way of teaching. Our
                tutors help people learn the fundamentals of Islam and
                Tajweed-e-Quran without having to be there in person.
                LearnQuranQuick has different Quranic and Islamic courses that
                can be tailored according to your requirements. We have a team
                of expert Quran teachers that are determined to guide others to
                the teachings and principles of Islam. Moreover, we have the
                availability of both the male and female staff to provide ease
                and comfort to the people.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={AboutUs1stpic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default PGAboutUs;
